export const getHour = (d: any) => Number(d.split(':')[0]);
